import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ componentStack: errorInfo?.componentStack || "" });
    console.error("SignalFly UI render error:", {
      message: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
      path: typeof window !== "undefined" ? window.location.pathname : "",
      workspace:
        typeof window !== "undefined"
          ? localStorage.getItem("signalfly.workspace.v1")
          : "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100svh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "#050a0f",
            color: "#e5e7eb",
            textAlign: "center",
          }}
        >
          <div>
            <h2 style={{ marginBottom: "12px" }}>Something went wrong</h2>
            <p style={{ maxWidth: "480px", lineHeight: 1.5 }}>
              The app hit a rendering problem. Please refresh and try again.
            </p>
            {this.state.error?.message && (
              <pre
                style={{
                  marginTop: "16px",
                  whiteSpace: "pre-wrap",
                  textAlign: "left",
                  maxWidth: "560px",
                  fontSize: "12px",
                  color: "#cbd5e1",
                }}
              >
                {this.state.error.message}
                {this.state.componentStack ? `\n\n${this.state.componentStack}` : ""}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
